// extracted by mini-css-extract-plugin
export default {"loaderContainer":"PageLoader_loaderContainer__N8Abb","loaderTitle":"PageLoader_loaderTitle__Jon-F"};